import { DocumentList, DocumentListDocument, DocumentListVariant } from "../../../../widget";

export type { DocumentListDocument, DocumentListVariant };

export interface TransactionAttachmentsProps {
  documents: DocumentListDocument[];
  variant?: DocumentListVariant;
  readOnly?: boolean;
  onAddAttachment: () => void;
  onRemove: (documentUuid: string) => void;
  onDownload?: (documentUuid: string) => void;
}

export const TransactionAttachments = ({
  documents,
  variant = "seed",
  readOnly = false,
  onAddAttachment,
  onRemove,
  onDownload,
}: TransactionAttachmentsProps): JSX.Element => {
  return (
    <DocumentList
      documents={documents}
      variant={variant}
      readOnly={readOnly}
      title="Attachments"
      addButtonText="Add attachment"
      emptyText="No attachments"
      onAddAttachment={onAddAttachment}
      onRemoveDocument={onRemove}
      onDownloadDocument={onDownload}
    />
  );
};
